export default "__VITE_ASSET__a17262d6__"